import api from '@/legacy/services/api';
import urls from '@/legacy/config/env';

const normalizeTagSegments = (pathname: string): string =>
	pathname.replace(/(\/(?:tags-nfc|qrs)\/whitelist\/details\/)([^/]+)/, '$1tag');

export const normalizeUrl = (pathname: string) => {
	return normalizeTagSegments(pathname)
		.replace(/^\/app\//, '')
		.replace(/-/g, '')
		.split('/')
		.map((seg) => (/^\d+$/.test(seg) ? 'details' : seg))
		.join('_');
};

export const trackUrl = async (pathname: string) => {
	if (!pathname) return;

	const normalized = normalizeUrl(pathname);
	const url = `${urls.tracking.trackUrls}?tracked_url=${encodeURIComponent(normalized)}`;
	await api.post(url);
};
